import React from 'react';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';

// Shared disclosure banner for any surface that renders synthetic/sample
// values instead of tenant-computed data. Keeping the wording centralized
// makes the demo-vs-live distinction consistent across role workspaces.
const SyntheticPreviewBanner = ({ message }) => (
    <Flex
        align="flex-start"
        gap={3}
        bg="orange.50"
        borderWidth="1px"
        borderColor="orange.200"
        borderRadius="12px"
        px={4}
        py={3}
    >
        <Icon as={FiInfo} color="orange.600" mt="2px" />
        <Box>
            <Text fontSize="13px" fontWeight="800" color="orange.800">
                Illustrative preview · synthetic data
            </Text>
            <Text fontSize="12.5px" color="orange.700">
                {message || 'The values below are a synthetic sample, not computed from this tenant. Upload the matching firm datasets to activate live numbers.'}
            </Text>
        </Box>
    </Flex>
);

export default SyntheticPreviewBanner;
